"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCookieVerdi = getCookieVerdi;
exports.skyraScriptURL = exports.getMatomoURLs = exports.getMatomoServerURL = void 0;
var _constants = require("./constants");
const sjekkMiljø = () => {
  if (typeof window === 'undefined') return 'test';
  return window.location.hostname.endsWith('skatteetaten.no') ? 'prod' : 'test';
};
const getMatomoServerURL = miljø => {
  return _constants.MATOMO_SERVER_URLS[miljø || sjekkMiljø()];
};
exports.getMatomoServerURL = getMatomoServerURL;
const getMatomoURLs = miljø => {
  const serverURL = getMatomoServerURL(miljø);
  return {
    serverURL,
    trackerURL: `${serverURL}/matomo.php`,
    scriptURL: `${serverURL}/matomo.js`
  };
};
exports.getMatomoURLs = getMatomoURLs;
function getCookieVerdi(cookieNavn) {
  const listeMedCookies = decodeURIComponent(document.cookie).split(';');
  for (const cookie of listeMedCookies) {
    const [navn, verdi] = cookie.trim().split('=');
    if (navn === cookieNavn) {
      return verdi;
    }
  }
  return undefined;
}
const skyraScriptURL = exports.skyraScriptURL = `${getMatomoServerURL()}/skyra-survey.js`;